<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;">
            <span class="text-muted fw-light">Business Profile /</span> Bank Details
        </h4>

        <mat-card>
            <mat-card-header class="mt-3">
                <span class="material-icons" style="margin-right: 10px;">
                    account_balance </span>Bank Details
            </mat-card-header>

            <hr class="my-0 mt-3 mb-2" />

            <mat-card-content>
                <form [formGroup]="customerBankAccountSetupForm" (ngSubmit)="onSubmit()">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Bank Routing Number</mat-label>
                                    <input matInput formControlName="BankRoutingNumber" id="BankRoutingNumber"
                                        name="BankRoutingNumber" (keypress)="numberOnly($event)"
                                        (keypress)="routingNumValidations($event)" (mouseout)="routingNum()"
                                        [ngClass]="{'is-invalid' : submitted && forms.BankRoutingNumber.errors}"
                                        required>
                                    <mat-error *ngIf="submitted && forms.BankRoutingNumber.errors "
                                        class="invalid-feedback">
                                        <div *ngIf="forms.BankRoutingNumber.errors.required"> This field is required
                                        </div>
                                        <div *ngIf="forms.BankRoutingNumber.errors.pattern">Enter number only</div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Bank Name</mat-label>
                                    <input matInput type="text" formControlName="NameOfBank" id="NameOfBank"
                                        name="NameOfBank"
                                        [ngClass]="{'is-invalid':submitted && forms.NameOfBank.errors}" required
                                        disabled>
                                    <mat-error *ngIf="submitted && forms.NameOfBank.errors" class="invalid-feedback">
                                        <div *ngIf="forms.NameOfBank.errors.required"> This field is required </div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Tax ID Number</mat-label>
                                    <input matInput formControlName="CompanyTaxId" id="CompanyTaxId"
                                        name="CompanyTaxId">
                                    <!-- [ngClass]="{'is-invalid' : submitted && forms.CompanyTaxId.errors}" required>
                                    <mat-error *ngIf="submitted && forms.CompanyTaxId.errors " class="invalid-feedback">
                                        <div *ngIf="forms.CompanyTaxId.errors.required"> This field is required
                                        </div>
                                    </mat-error> -->
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Bank Address</mat-label>
                                    <input matInput formControlName="BankAddress" id="BankAddress" name="BankAddress">
                                    <!-- [ngClass]="{'is-invalid' : submitted && forms.BankAddress.errors}" required>
                                    <mat-error *ngIf="submitted && forms.BankAddress.errors " class="invalid-feedback">
                                        <div *ngIf="forms.BankAddress.errors.required"> This field is required
                                        </div>
                                    </mat-error> -->
                                </mat-form-field>

                                <!-- <mat-form-field appearance="outline">
                                    <mat-label>E-mail</mat-label>
                                    <input matInput formControlName="PaymentEmailAddress" id="PaymentEmailAddress"
                                        name="PaymentEmailAddress"
                                        [ngClass]="{'is-invalid' : submitted && forms.PaymentEmailAddress.errors}">
                                    <mat-error *ngIf="submitted && forms.PaymentEmailAddress.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="forms.PaymentEmailAddress.errors.required"> This field is required
                                        </div>
                                        <div *ngIf="forms.PaymentEmailAddress.errors.email">Email must be a valid email
                                            address</div>
                                        <div *ngIf="forms.PaymentEmailAddress.errors.pattern">The Email is not valid
                                            email address
                                        </div>
                                    </mat-error>
                                </mat-form-field> -->
                                <mat-form-field appearance="outline">
                                    <mat-label>Bank Phone Number</mat-label>
                                    <input matInput formControlName="BankContactPhone" id="BankContactPhone"
                                        name="BankContactPhone" placeholder="XXX-XXX-XXXX" (keypress)="onPress($event)"
                                        [ngClass]="{'is-invalid':submitted && forms.BankContactPhone.errors}"
                                        appPhoneMask appNumericOnly autocomplete="off">
                                    <mat-error *ngIf="submitted && forms.BankContactPhone.errors"
                                        class="invalid-feedback">
                                        <!-- <div *ngIf="forms.BankContactPhone.errors.required">Phone Number is required
                                        </div> -->
                                        <div *ngIf="forms.BankContactPhone.errors.pattern">Please, Enter 10 digit Mobile
                                            Number</div>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Bank Account Number</mat-label>
                                    <input matInput formControlName="AccountNumber" id="AccountNumber"
                                        name="AccountNumber" (keypress)="numberOnly($event)"
                                        [ngClass]="{'is-invalid' : submitted && forms.AccountNumber.errors}" required>
                                    <mat-error *ngIf="submitted && forms.AccountNumber.errors" class="invalid-feedback">
                                        <div *ngIf="forms.AccountNumber.errors.required"> This field is required</div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Confirm Account Number</mat-label>
                                    <input type="password" matInput formControlName="ConfirmAccNum" id="ConfirmAccNum"
                                        name="ConfirmAccNum" (keypress)="numberOnly($event)"
                                        [ngClass]="{'is-invalid' : submitted && forms.ConfirmAccNum.errors}" required>
                                    <mat-error *ngIf="submitted && forms.ConfirmAccNum.errors" class="invalid-feedback">
                                        <div *ngIf="forms.ConfirmAccNum.errors.required"> This field is required</div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Bank Account Type </mat-label>
                                    <input matInput formControlName="AccountType" id="AccountType" name="AccountType">
                                    <!-- [ngClass]="{'is-invalid' : submitted && forms.AccountType.errors}" required>
                                    <mat-error *ngIf="submitted && forms.AccountType.errors" class="invalid-feedback">
                                        <div *ngIf="forms.AccountType.errors.required"> This field is required</div>
                                    </mat-error> -->
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Payment Selection Method </mat-label>
                                    <input matInput formControlName="PaymentSelection" id="PaymentSelection"
                                        name="PaymentSelection">
                                    <!-- [ngClass]="{'is-invalid' : submitted && forms.PaymentSelection.errors}"
                                        required>
                                    <mat-error *ngIf="submitted && forms.PaymentSelection.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="forms.PaymentSelection.errors.required"> This field is required
                                        </div>
                                    </mat-error> -->
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Bank Zip Code</mat-label>
                                    <input matInput formControlName="BankZipCode" id="BankZipCode" name="BankZipCode"
                                        (keypress)="numberOnly($event)"
                                        [ngClass]="{'is-invalid':submitted && forms.BankZipCode.errors}">
                                    <mat-error *ngIf="submitted  && forms.BankZipCode.errors" class="invalid-feedback">
                                        <!-- <div *ngIf="forms.BankZipCode.errors.required">ZipCode is required</div> -->
                                        <div *ngIf="forms.BankZipCode.errors.minlength">Mininmum length is 5</div>
                                        <div *ngIf="forms.BankZipCode.errors.maxlength">Maximum length is 7</div>
                                    </mat-error>
                                </mat-form-field>

                                <!-- <mat-form-field appearance="outline" style="visibility: hidden;">
                                    <mat-label>Phone Number</mat-label>
                                    <input matInput>
                                </mat-form-field> -->
                            </div>
                        </div>
                    </div>
                    <alert></alert>
                    <mat-card-actions>
                        <button mat-raised-button class="buttonColor" type="submit" style="margin-left:40px;">
                            Save</button>
                    </mat-card-actions>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>